import { GlBadge, GlIcon, GlLoadingIcon } from '@gitlab/ui';
export default {
    name: 'DuoSingleSelectOptions',
    components: {
        GlBadge,
        GlIcon,
        GlLoadingIcon
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        submittingId: {
            type: String,
            required: false,
            default: null
        },
        unchosen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'select'
    ]
};
